module.exports = __webpack_public_path__ + "static/14-277c694cefc16818014de16b38c6d237.jpg";